import { CommApiInstance } from "Utils/CommApiInstance";




const MembAccnDtlInfoInqApi = async (
) => {
    return await CommApiInstance.post("memb/memb",{
        apiBody:{
        },
    })
    .then((Resp) => Resp.data);
}
export default MembAccnDtlInfoInqApi;